import type { Dispatch, SetStateAction } from 'react';
import type { AddItemVisibility } from 'src/components/add-item/types';
import { Text } from '@savvy-kit/foundations/text';
import { CircleCheck } from 'lucide-react';
import TrackedButton from 'src/components/tracked/tracked-button';

import { successColors } from '@savvy/deprecated-shared/theme';

function MobileConnectAccountPreview({
  setShowAddItemDialog,
}: {
  readonly setShowAddItemDialog: Dispatch<SetStateAction<AddItemVisibility | undefined>>;
}) {
  return (
    <div className="flex flex-col gap-8 items-center h-[97.75vh] pt-12 px-4 bg-background-light">
      {/* eslint-disable-next-line @next/next/no-img-element -- preview asset is a fixed Cloudinary marketing image */}
      <img src="https://res.cloudinary.com/hbb0rvydd/image/upload/v1715702865/client-dashboard-assets/mobile-networth-preview_enp4c5.png" />
      <Text variant="h4" color="dark">
        All your wealth in one place
      </Text>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-2">
          <CircleCheck color={successColors.main} style={{ marginTop: '2px' }} />
          <Text variant="body-sm" color="dark">
            One app for all of your investment accounts, bank accounts, and any other type of asset.
          </Text>
        </div>
        <div className="flex flex-row gap-2">
          <CircleCheck color={successColors.main} style={{ marginTop: '2px' }} />
          <Text variant="body-sm" color="dark">
            Your advisor has visibility so they can make the best recommendations to meet your goals.
          </Text>
        </div>
      </div>
      <TrackedButton
        elementName="mobile-web-connect-account-preview-connect-account-button"
        onClick={() => {
          setShowAddItemDialog('VISIBLE');
        }}
        size="lg"
        className="w-full"
      >
        Connect an account
      </TrackedButton>
    </div>
  );
}

export default MobileConnectAccountPreview;
